<template>
  <div>
    <div>
      <app-header/>
      <router-view/>
      <app-footer/>
      <div id="snackbar" style="z-index: 20000">Some text some message..</div>
    </div>
  </div>
</template>

<script>
import AppHeader from "./component/common/AppHeader";
import AppFooter from "./component/common/AppFooter";
export default {
  name: "index",
  components: {AppFooter, AppHeader},
  computed: {
  }
}
</script>